<script>
import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericCustomMasterDataAutocompleteV2 from '../../generic/GenericCustomMasterDataAutocompleteV2.vue'
import GenericCustomAutocompleteV2 from '../../generic/GenericCustomAutocompleteV2.vue'
import GenericBooleanDropdown from '../../generic/GenericBooleanDropdown.vue'
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import RadioButton from 'primevue/radiobutton';

import ResponsiveButton from '../../generic/ResponsiveButton.vue'
import DialogBiodieselMixingReport from '../../../components/operative-plan/daily-plan-management/DialogBiodieselMixingReport.vue';
import DialogTankInformation from '../../../components/tank-management/TankInformationDialog.vue';
import DeviationCalculator from '../../../views/equipment-operation/DeviationCalculator.vue';

import Service from '../../../services/equipment-operation';
import FiscalNotificationService from '../../../services/fiscal-notification';

const levelMeasureRequired = helpers.withMessage('Value is required', function(el){
    if(this.data.measureType == 'LEVEL'){
        return el != null;
    }
    return true;
});

const quantityMeasureRequired = helpers.withMessage('Value is required', function(el){
    if(this.data.measureType == 'QUANTITY'){
        return el != null;
    }
    return true;
});

const isGasRequired = helpers.withMessage('Value is required', function(el){
    if(this.data.measureType == 'LEVEL' && this.data.isGas){
        return el;
    }
    return true;
});

const customQuantityLevelRequired = helpers.withMessage('At least one of stock weight or moved weight must be filled', function(el){
    if(this.data.measureType == 'QUANTITY' && !this.isAzzPd){

        if(this.isSetStorage){
            if((this.data.fiscalStockWeight != null && this.data.fiscalStockWeight >=0) || (this.data.fiscalMovedWeight != null && this.data.fiscalMovedWeight >= 0) ){
                return true;
            }
        }else{
            if(this.data.fiscalStockWeight || this.data.fiscalMovedWeight){
                return true;
            }
        }
        return false;
    }
    return true;
})

export default{
    setup: () => ({ v$: useVuelidate() }),
    props: ['id'],
    components: {
        Fieldset, DeviationCalculator,
        InputText, InputNumber, Calendar, Dropdown, RadioButton,
        ResponsiveButton, DialogBiodieselMixingReport,
        GenericCustomMasterDataAutocompleteV2, GenericCustomAutocompleteV2, GenericBooleanDropdown, DialogTankInformation
    },
    created(){
        if(this.id != 0){
            this.loadOperation();
        }else{
            if(this.$route.query.tankCode){
                this.data.tankCode = this.$route.query.tankCode;
            }
            // if(this.$route.query.plantCode){
            //     this.data.plantCode = this.$route.query.plantCode;
            // }

            if(this.$route.query.idScheduledOperation){
                let operationData = this.$store.getters['operativePlan/getNewOperationData'](this.$route.query.idScheduledOperation);
                if(operationData){

                    this.populateOperation(operationData.data, operationData.mode)
                    this.data.idRegistryOperationType = operationData.selectedRecord.idRegistryOperationType;
                    this.data.tankCode = operationData.tankCode;
                    this.data.otherTankCode = operationData.otherTankCode;
                    this.data.operationStatus = 'CP';
                    this.data.combinedNomenclature = operationData.selectedRecord.energyProductDetail;
                    this.data.operationCircuit= operationData.selectedRecord.fiscalCircuit;
                    this.isFromDailyPlan = true;
                    this.data.fiscalCommunicationCode = operationData.selectedRecord.utifProgramCode;

                    this.fixedSender = operationData.fixedSender;
                    if(this.fixedSender){
                        this.data.isSender = operationData.isSender;
                    }

                    this.data.voyageNumber = operationData.selectedRecord.voyageNumber;
                    this.data.idProductOwner = operationData.selectedRecord.idOwnerCompany;
                    this.isNotifyToCustomAgency = operationData.selectedRecord.isNotifyToCustomAgency;

                    
                    this.data.isPartialMeasure =  operationData.selectedRecord.isPartialEndNotificationWithOnlyInputParams;
                    if(operationData.selectedRecord.isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled){
                        this.isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled = true;
                        this.data.operationStatus = 'CC';
                        let body = {
                            tankCode: this.data.tankCode,
                            date: this.data.operationDate
                        }
                        
                        Service.getLastOperation(body, response => {
                            if(response.success){
                                let lastOperation = response.data;
                                if(lastOperation){
                                    this.data.operationCircuit = lastOperation.operationCircuit;
                                    this.data.combinedNomenclature = lastOperation.combinedNomenclature;
                                }
                            }
                        })
                    }

                    
                }
            }else{
                this.data.operationStatus = 'CC';
            }
        }
        
    },
    watch: {
        'data.measureType'(n){
            if(n == 'QUANTITY'){
                this.data.stockWeight = this.data.fiscalStockWeight;
                this.data.stockVolume15 = this.data.fiscalStockVolume;
                this.data.movedVolume = this.data.fiscalMovedVolume;
                this.data.movedWeight = this.data.fiscalMovedWeight;
            }
        },
        'data.fiscalStockWeight'(n){
            if(this.data.measureType == 'QUANTITY'){
                this.data.stockWeight = n;
            }
        },
        'data.fiscalStockVolume'(n){
            if(this.data.measureType == 'QUANTITY'){
                this.data.stockVolume15 = n;
            }
        },
        'data.fiscalMovedVolume'(n){
            if(this.data.measureType == 'QUANTITY'){
                this.data.movedVolume = n;
            }
        },
        'data.fiscalMovedWeight'(n){
            if(this.data.measureType == 'QUANTITY'){
                this.data.movedWeight = n;
            }
        },
        'data.operationDate'() {
            Utils.nullSAndMS(this.data.operationDate)
        }
    },
    validations(){
        return {
            data: {
                // plantCode: { required },
                tankCode: {required},
                otherTankCode: {},
                operationStatus: {},
                operationCircuit: {required},
                operationDate: {required},
                measureType: {required},
                managementType: {required},
                idRegistryOperationType: {required},
                idRegistryProduct: {required},
                temperature: { levelMeasureRequired },
                density15: { levelMeasureRequired },
                productLevel: { levelMeasureRequired },
                waterLevel: { levelMeasureRequired },
                waterVolume: { levelMeasureRequired },
                grossVolume: { levelMeasureRequired },
                fX54: { levelMeasureRequired },
                fX56: { levelMeasureRequired },
                stockVolume15: { levelMeasureRequired },
                stockWeight: { levelMeasureRequired },
                gasPressure: { isGasRequired},
                steamWeight: {isGasRequired},
                molecularWeight: {isGasRequired},
                gasTemperature: {isGasRequired},
                removableVolume: {levelMeasureRequired},
                removableWeight: {levelMeasureRequired},

                fiscalStockWeight: {customQuantityLevelRequired},
                fiscalMovedWeight: {customQuantityLevelRequired},
                combinedNomenclature: {required}
                // tankCode: {required, maxLength: maxLength(20)},
                // isSender: {required},
                // operationCircuit: {required, maxLength: maxLength(2)},
                // operationDate: {required},
                // measureType: {required, maxLength: maxLength(20)},
                // idRegistryOperationType: {required},
                // idRegistryProduct: {required},
                // isGas: {required},
                // operationStatus: {},
                // fiscalStockWeight: {required},
                // fiscalStockVolume: {required},
                // fiscalMovedVolume: {required},
                // fiscalMovedWeight: {required},
                // stockVolume15: { required },
                // stockWeight: {},
                // movedVolume: {},
                // movedWeight: {},
                // stockVolume: {},

                // plantCode: { maxLength: maxLength(20) },
                // otherTankCode: { maxLength: maxLength(20) },
                // managementType: { maxLength: maxLength(20) ,
                // voyageNumber: { maxLength: maxLength(20) }},
                // fiscalCommunicationCode: { maxLength: maxLength(10) },
                // fiscalDocumentNumber: { maxLength: maxLength(50) },
                // fiscalDocumentType: { maxLength: maxLength(10) },
                // combinedNomenclature: { maxLength: maxLength(50) },
                // feetPosition: { maxLength: maxLength(1) },
                // environmentTemperatureSensor: { maxLength: maxLength(40) },
                // plantCode: {  },
                // temperature: {  },
                // density15: {  },
                // productLevel: {  },
                // waterLevel: {  },
                // waterVolume: {  },
                // grossVolume: {  },
                // fX54: {  },
                // fX56: {  },
                // gasPressure: { },
                // steamWeight: {},
                // molecularWeight: {},
                // gasTemperature: {},
                // removableVolume: {},
                // removableWeight: {}
            }
        }
    },
    data(){
        return{
            operationType: null,
            productData: null,
            isAzzPd: false,
            isSetStorage: false,
            isFromDailyPlan: false,
            isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled: false,
            isNotifyToCustomAgency: false,
            filter: {
                calculationMode: 'TANK'
            },
            biodieselMixingDialogVisible: false,
            deviationCalculatorVisibility: false,
            submitted: false,
            allLinkedTanks: [],
            data: {
                // plantCode: null,
                tankCode: null,
                otherTankCode: null,
                measureType: 'LEVEL',
                voyageNumber: this.$route.query.voyageNumber,
                isSender: false,
                operationStatus: null,
                operationCircuit: null,
                operationDate: null,
                managementType: 'Pure Product',
                idProductOwner: null,
                idRegistryOperationType: null,
                idOperativePlan: this.$route.query.idScheduledOperation,
                fiscalCommunicationCode: this.$route.query.utifProgramCode,
                fiscalDocumentNumber: null,
                fiscalDocumentType: null,
                fiscalStockWeight: null,
                fiscalStockVolume: null,
                fiscalMovedVolume: null,
                fiscalMovedWeight: null,
                idRegistryProduct: null,
                combinedNomenclature: this.$route.query.nc,
                isGas: false,
                temperature: null,
                density15: null,
                productLevel: null,
                waterLevel: null,
                waterVolume: null,
                grossVolume: null,
                fx54: null,
                fx56: null,
                gasPressure: null,
                stockVolume15: null,
                stockWeight: null,
                movedVolume: null,
                movedWeight: null,
                steamVolume: null,
                stockVolume: null,
                removableVolume: null,
                removableWeight: null,
                sulfurPercentage: null,
                emptyStockWeight: null,
                steamWeight: null,
                molecularWeight: null,
                gasTemperature: null,
                shrinkage: null,
                shrinkageGas: null,
                denaturantQuantity: null,
                idDenaturant: null,
                roofVolume: null,
                roofWeight: null,
                feetPosition: null,
                environmentTemperature: null,
                environmentTemperatureSensor: null,
                shellTemperature: null,
                thermalExpansionFactor: null,
                deltaTemperatura: null,
                shellVolume: null,
                introducedGrossVolume: null,
                introducedGrossWeight: null,
                sampleBarrelDensity15: null,
                weightedAverageDensity: null,
                waterAndSedimentsVolumePercentage: null,
                waterAndSedimentsCorrectionFactor: null,
                waterAndSedimentsIntroducedVolume: null,
                volumeExpansionFactor: null,
                biofeedWeightCorrectiornFactor: null,
                automaticProductLevel: null,
                automaticTemperature: null,
                automaticStockWeight: null,
                automaticMovedWeight: null,
                automaticStockVolume: null,
                automaticMovedVolume: null,
                deltaMovedQuantity: null,
                deltaMovedPercentage: null,
                idOwnerCompany: null,
                voyageNumber: null,

                switchSenderReceiver: false,
                isPartialMeasure: false
            },
            measureTypesOptions: [
                { value: 'LEVEL'},
                { value: 'QUANTITY'}
            ],
            managementTypesOptions: ['Pure Product','Promiscous'],
            footPositionOptions: [
                { value: 'D' },
                { value: 'U' }
            ],
            showPopupNotAllFiscalZeroingOnTanks: false,
            showTankInfo: false,
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        ncApi(){
        if(this.data.idRegistryProduct){
            let getOnlyValid = this.id == null || this.id == 0;
            return `masterdata/energy-product-detail-combonc?idProduct=${this.data.idRegistryProduct}&transportType=N&getOnlyValid=${getOnlyValid}`;
        }
        return null;
      },
      uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadOperation(){
            Service.getOperation(this.id, response => {
                if(response.success){
                    this.data = response.data;

                    if(this.data.operationDate){
                        this.data.operationDate = Utils.dateToCurrentTimeZone(this.data.operationDate);
                    }
                }
            })
        },
        populateCalculator(){
            let input = {...this.data};
            input.registryOperationType = this.operationType.shortDescription;
            input.otherTank = this.data.isSender ? input.otherTankCode : input.tankCode;
            input.mainTank = this.data.isSender ? input.tankCode : input.otherTankCode;
            this.$emit('populateCalculator', input);
        },
        populateOperation(data, mode, checkAzzPd){

            if(checkAzzPd && this.isAzzPd){
                this.$toast.add({detail: this.$t('tankOperations.azzPDWarning'), life:3000, severity:'error'});
                return;
            }

            this.data = {...this.data, ...data};

            this.data.fiscalStockWeight = data.stockWeight;
            this.data.fiscalStockVolume = data.stockVolume15;

            this.filter.calculationMode = mode;

            Service.checkMovedQuantitiesSign(
                this.data, 
                ({success, data}) => {
                    if(success){
                        this.data.fiscalMovedVolume = data.volume15;
                        this.data.fiscalMovedWeight= data.weight
                    }
                }
            );

        },
        onTankSelected(event){
            if(event.value){
                this.data.feetPosition = event.value.feetPosition;
            }
        },
        onProductSelected(product){
            this.productData = product;
            this.data.isGas = product.extraData.isGas;
            let getOnlyValid = this.id == null || this.id == 0;
            this.$refs.ncCombo.loadOptions(`masterdata/energy-product-detail-combonc?idProduct=${this.data.idRegistryProduct}&transportType=N&getOnlyValid=${getOnlyValid}`);
        },
        onOperationSelected(event){

            this.operationType = event.value;

            if(event.value){
                // 08.02.2023 - CARLO mi ha detto che C -> OUT, quindi in caso parlate con lui
                if(event.value.code == "06"){
                    this.data.measureType = 'QUANTITY';
                    this.data.stockWeight = 0;
                    this.data.fiscalStockWeight = 0;
                    this.data.stockVolume15 = 0;
                    this.data.fiscalStockVolume = 0;
                    this.isAzzPd = true;
                }else{
                    this.isAzzPd = false;
                }

                if(!this.fixedSender && (this.id == null || this.id == 0)){
                    this.data.isSender = event.value.sourceOrRecipientFlag == 'M';
                }
                this.isSetStorage = event.value.isSetStorage;

            }
        },
        onPlantSelected(event){
            let plantId = event.value.id;

            let tankApi = `masterdata/equipment-combo?getOnlyValid=true&type=SERB&plantId=${plantId}`;
            this.$refs.tankSelectAC.loadOptions(tankApi);
        },
        onSave(valid){
            
            this.submitted = true;
            if (this.v$.data.$invalid){
                return;
            }

            this.submitted = false;
            if(this.id != 0){
                this.save(valid);
            }else{
                this.checkOperationTanks(valid);
            }
        },
        closeBiodieselMixingReportDialog(value){
            this.biodieselMixingDialogVisible = !value;
        },
        closeDeviationCalculatorDialog(){
            this.deviationCalculatorVisibility = false;
        },
        afterDeviationCalculatorSaved(){
            this.redirect(this.id);
        },
        afterBiodieselMixingReportSaved(){
            this.redirect(this.id);
        },
        checkDeviation(id, creation){
            Service.checkTankCvtDeviation({operationDate: this.data.operationDate, tank: this.data.tankCode, idRegistryProduct: this.data.idRegistryProduct}, 
            ({success, data}) => {
                if (success && data.calculation) {
                    if (data.linkedTanks.length == 0){
                        this.deviationCalculatorVisibility = true;
                    } else {
                        let tanksLabel = data.tank;
                        data.linkedTanks.forEach(({tank}) =>{
                            tanksLabel = tanksLabel + ", " + tank;
                        })
                        this.$confirm.require({
                            message: this.$t('cvtDeviation.manageMultipleTanks').replace('{tanks}', tanksLabel),
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: this.$t('yes'),
                            rejectLabel: this.$t('no'),
                            accept: () => {
                                this.allLinkedTanks = [data.tank, ...data.linkedTanks.map((item) => item.tank)]

                                if (data.linkedTanks.every((item) => item.fiscalZeroingExists)){
                                    this.deviationCalculatorVisibility = true;
                                } else {
                                    this.showPopupNotAllFiscalZeroingOnTanks = true;
                                }
                                this.$confirm.close()
                            },
                            reject: () => {
                                this.allLinkedTanks = [data.tank]
                                this.deviationCalculatorVisibility = true;
                                this.$confirm.close()
                            }
                        });
                    }
                } else {
                    if(creation){
                        this.redirect(id);
                    }
                }
            })
        },
        redirect(id){
            if (this.data.idOperativePlan) {
                this.$router.push(
                    {
                        name: 'daily-plan-management',
                        // query: {
                        //     idScheduledOperation: this.data.idOperativePlan,
                        // }
                    }
                )
            } else if(this.isFromDailyPlan){
                this.$router.push({ name: 'daily-plan-management' });
            }else {
                this.$router.push(
                    {
                        name: 'tank-operation-detail',
                        params: {
                            id: id,
                            startInEdit: true
                        }
                    }
                )
            }
        },
        save(valid){

            if(this.data.measureType == 'LEVEL'){

                if(this.filter.calculationMode == 'TANK'){
                    //this.data.sulfurPercentage = null;
                    this.data.emptyStockWeight = this.data.emptyStockWeight ? this.data.emptyStockWeight : null;
                    this.data.introducedGrossVolume = null;
                    this.data.introducedGrossWeight = null;
                    this.data.sampleBarrelDensity15 = null;
                    this.data.weightedAverageDensity = null;
                    this.data.waterAndSedimentsVolumePercentage = null;
                    this.data.waterAndSedimentsCorrectionFactor = null;
                    this.data.waterAndSedimentsIntroducedVolume = null;
                }

            }else if(this.data.measureType == 'QUANTITY'){
                this.data.temperature = null;
                this.data.productLevel = null;
                this.data.waterLevel = null;
                this.data.grossVolume = null;
                this.data.fx54 = null;
                this.data.fx56 = null;
                //this.data.stockVolume15 = null;
                this.data.removableVolume = null;
                this.data.removableWeight = null;
            }


            this.$store.dispatch("generic/setLoading", true);

            if(this.id != 0){
                Service.saveOperation(this.data,
                    ({success, message}) => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(success){
                            if(this.data.combinedNomenclature){
                                Service.getIsAccertamentoProduzione({combinedNomenclature: this.data.combinedNomenclature, idRegistryOperationType: this.data.idRegistryOperationType} , ({success, data}) => {
                                    if(success && data){
                                        FiscalNotificationService.getBiodieselMixingReport({idScheduled: this.data.idOperativePlan}, ({success}) => {
                                            if(success){
                                                this.biodieselMixingDialogVisible = true;
                                                this.$refs.DialogBiodieselMixingReport.refreshData(this.data.idOperativePlan);
                                            }
                                        })
                                    }
                                })
                            }
                            Service.getIsAzzeramentoPiedeCVT({operationStatus: this.data.operationStatus, idRegistryOperationType: this.data.idRegistryOperationType} , ({success, data}) => {
                                if(success && data){
                                    this.checkDeviation(data.id, false);
                                }
                            })
                            this.loadOperation();
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        }else{
                            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
                );
            }else{
                 Service.checkMovedQuantitiesSign(
                    this.data, 
                    response => {
                        
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.data.switchSenderReceiver = false;
                            this.createOperation()
                        }else{
                            if(response.data != null){
                                // POPUP

                                if(response.data.switchSenderReceiverEnabled){
                                    this.$confirm.require({
                                        message: this.$t('tankOperations.movedQuantitiesNegativeMessageForSwitchSenderReceiver'),
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: this.$t('yes'),
                                        rejectLabel: this.$t('no'),
                                        accept: () => {
                                            this.data.switchSenderReceiver = response.data.switchSenderReceiverEnabled;
                                            this.createOperation();
                                        },
                                        reject: () => {
                                            this.$confirm.close()
                                        }
                                    });
                                }else if(!response.data.isLayerStockAvailable){
                                    this.$confirm.require({
                                        message: this.$t('tankOperations.isLayerStockAvailableMessage'),
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: this.$t('yes'),
                                        rejectLabel: this.$t('no'),
                                        accept: () => {
                                            // AZZERARE LE GIACENZE, METTERE I VOVIMENTATI e SETTARE A QUANTITA LA MISURA, SVUOTARE TUTTI I CAMPI "LIVELLO";
                                            this.data.fiscalStockVolume = 0;
                                            this.data.fiscalStockWeight = 0;
                                            this.data.stockVolume = 0;
                                            this.data.stockVolume15 = 0;
                                            this.data.stockWeight = 0;


                                            this.data.measureType = 'QUANTITY';
                                            this.data.movedVolume = response.data.volume15;
                                            this.data.movedWeight =  response.data.weight;

                                            this.data.fiscalMovedVolume = response.data.volume15;
                                            this.data.fiscalMovedWeight =  response.data.weight;
                                           
                                            this.createOperation();
                                        },
                                        reject: () => {
                                            this.$confirm.close()
                                        }
                                    });
                                }else{
                                    // TODO - METTERE MESSAGGIO
                                    this.$toast.add({detail: this.$t('tankOperations.movedQuantitiesNegativeMessageForWarning'), life:3000, severity:'error'});
                                }
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }


                    });
                
            }
        },
        createOperation(){
            
            this.$store.dispatch("generic/setLoading", true);
            Service.createOperation(
                this.data,
                response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        if(this.data.combinedNomenclature){
                            Service.getIsAccertamentoProduzione({combinedNomenclature: this.data.combinedNomenclature, idRegistryOperationType: this.data.idRegistryOperationType} , ({success, data}) => {
                                if(success && data){
                                    FiscalNotificationService.getBiodieselMixingReport({idScheduled: this.data.idOperativePlan}, ({success}) => {
                                        if(success){
                                            this.biodieselMixingDialogVisible = true;
                                            this.$refs.DialogBiodieselMixingReport.refreshData(this.data.idOperativePlan);
                                        }
                                    })
                                } else {
                                    Service.getIsAzzeramentoPiedeCVT({operationStatus: this.data.operationStatus, idRegistryOperationType: this.data.idRegistryOperationType} , ({success, data}) => {
                                        if(success && data){
                                            this.checkDeviation(data.id, true);
                                        } else{
                                            this.redirect(data.id);
                                        }
                                    })
                                }
                            })
                        } else {
                            Service.getIsAzzeramentoPiedeCVT({operationStatus: this.data.operationStatus, idRegistryOperationType: this.data.idRegistryOperationType} , ({success, data}) => {
                                if(success && data){
                                    this.checkDeviation(data.id, true);
                                } else{
                                    this.redirect(data.id);
                                }
                            })
                        }
                    //let uri = `/tank/operations/${response.data.id}`;

                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            );
        },

        checkOperationTanks(valid){
            Service.checkOperationTank({idRegistryOperationType: this.data.idRegistryOperationType, tankCode: this.data.tankCode} , ({success, data, message}) => {
                if(success){
                    if(data){
                        this.$confirm.require({
                            message: this.$t('tankOperations.checkOperationTankAlert') + ' ' +this.$t('tankOperations.sequence') + message,
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: this.$t('yes'),
                            rejectLabel: this.$t('no'),
                            accept: () => {
                                this.data.forceTankOperationInput = true;             
                                this.save(valid);
                            },
                            reject: () => {
                                this.$confirm.close();
                            }
                        });
                    }else{
                        this.save(valid);
                    }                   
                }else{
                    this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }                
            });           
        },
        closeTankInformationDialog(value){
            this.showTankInfo = !value;
        },
    }
}
</script>

<template>
    <main>
        <DeviationCalculator :tanks="allLinkedTanks.length > 0 ? allLinkedTanks : [data.tankCode]" :operationDate="data.operationDate" :isGas="data.isGas" :visible="deviationCalculatorVisibility" @close-deviation-calculator-dialog="closeDeviationCalculatorDialog" @after-deviation-calculator-saved="afterDeviationCalculatorSaved"/>
        <DialogBiodieselMixingReport :visible="biodieselMixingDialogVisible" :idScheduled="data.idOperativePlan" @close-biodiesel-mixing-report-dialog="closeBiodieselMixingReportDialog" ref="DialogBiodieselMixingReport" @after-biodiesel-mixing-report-saved="afterBiodieselMixingReportSaved" />
        <DialogTankInformation :visible="showTankInfo" :tankCode="data.tankCode" @close-tank-information="closeTankInformationDialog"/>
        <div class="grid">
            <Dialog v-model:visible="showPopupNotAllFiscalZeroingOnTanks" :header="'Info'" :style="{ width: '30vw' }">
                <p>{{ $t('cvtDeviation.notAllFiscalZeroingOnTanks').replace('{tanks}', allLinkedTanks) }}</p>
            </Dialog>
            <div class="col-12 m-1">
                <ResponsiveButton :label="$t('tankOperations.exportInCalculator')" icon="pi pi-table" class="p-button-sm m-1" @click="populateCalculator" :disabled="!uiPermissions('tankCalculatorExportButton').isEnabled || data.measureType == 'QUANTITY'" />
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="p-button-sm m-1" @click="onSave(!v$.$invalid)" :disabled="!uiPermissions('tankDetailSaveButton').isEnabled"/>
                <ResponsiveButton :label="$t('tankOperations.btn.showTankInfo')" icon="pi pi-database" class="p-button-sm p-button-outlined m-1" @click="showTankInfo = !showTankInfo"/>
            </div>
            <Fieldset class="col-12" :legend="$t('tankOperations.general')">
                <div class="grid">
                    <!-- <div class="col-12 lg:col-3 md:col-4 field">
                        <label for="plant" :class="{'p-error':v$.data.plantCode.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                        <GenericCustomAutocompleteV2
                            :disabled="false"
                            :onItemSelect="onPlantSelected"
                            name="plants-codes"
                            v-model="data.plantCode"
                            api="masterdata/registry-plant"
                            :format="{ label: 'code', value: 'code' }" sortField="Code"
                            :class="{'p-invalid':v$.data.plantCode.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.plantCode.$invalid && submitted) || v$.data.plantCode.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.plantCode.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div> -->
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label for="tank" :class="{'p-error':v$.data.tankCode.$invalid && submitted}">{{$t('tankOperations.tank')}}</label>
                        <GenericCustomAutocompleteV2
                            :disabled="isFromDailyPlan"
                            :onItemSelect="onTankSelected"
                            :class="{'p-invalid':v$.data.tankCode.$invalid && submitted, 'w-full p-inputtext-sm': true}"
                            v-model="data.tankCode"
                            ref="tankSelectAC"
                            name="tank-management-tank-combo"
                            :format="{ label: 'label', value: 'label' }"
                            api="masterdata/equipment-combo?getOnlyValid=true&type=SERB" />
                        <div v-if="(v$.data.tankCode.$invalid && submitted) || v$.data.tankCode.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.tankCode.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label for="tank" :class="{'p-error':v$.data.otherTankCode.$invalid && submitted}">{{$t('tankOperations.otherTank')}}</label>
                        <GenericCustomAutocompleteV2
                            :disabled="isFromDailyPlan"
                            :class="{'p-invalid':v$.data.otherTankCode.$invalid && submitted, 'w-full p-inputtext-sm': true}"
                            v-model="data.otherTankCode"
                            name="tank-management-tank-combo"
                            :format="{ label: 'label', value: 'label' }"
                            api="masterdata/equipment-combo?getOnlyValid=true&type=SERB" />
                        <div v-if="(v$.data.otherTankCode.$invalid && submitted) || v$.data.otherTankCode.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.otherTankCode.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label for="isSender">{{$t('tankOperations.isSender')}}</label>
                        <GenericBooleanDropdown
                            :disabled="isFromDailyPlan"
                            id="isSender"
                            v-model="data.isSender"
                            class="w-full p-inputtext-sm"/>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label for="opType" :class="{'p-error':v$.data.idRegistryOperationType.$invalid && submitted}">{{$t('operationType.fk')}}</label>
                        <GenericCustomAutocompleteV2
                            :onItemSelect="onOperationSelected"
                            :disabled="isFromDailyPlan"
                            :class="{'p-invalid':v$.data.idRegistryOperationType.$invalid && submitted, 'w-full p-inputtext-sm': true}"
                            v-model="data.idRegistryOperationType"
                            name="operation-type-tank-combo"
                            :format="{ label: 'description', value: 'id' }"
                            api="masterdata/operation-type" />
                        <div v-if="(v$.data.idRegistryOperationType.$invalid && submitted) || v$.data.idRegistryOperationType.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.idRegistryOperationType.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label :class="{'p-error':v$.data.operationStatus.$invalid && submitted}">{{$t('tankOperations.operationStatus')}}</label>
                        <InputText
                        :disabled="true" type="text"
                        v-model="data.operationStatus"
                        :class="{'p-invalid':v$.data.operationStatus.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.operationStatus.$invalid && submitted) || v$.data.operationStatus.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.operationStatus.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label :class="{'p-error':v$.data.operationCircuit.$invalid && submitted}">{{$t('tankOperations.operationCircuit')}}</label>

<!-- masterdata/fiscal-circuit-combo-->

                        <GenericCustomAutocompleteV2
                            :disabled="isFromDailyPlan && !isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled" 
                            v-model="data.operationCircuit"
                            api="masterdata/fiscal-circuit-combo"
                            :format="{ label: 'label', value: 'valueString' }"
                            :class="{'p-invalid':v$.data.operationCircuit.$invalid && submitted, 'w-full p-inputtext-sm': true}" />

                        <!-- <InputText type="text"
                            :disabled="isFromDailyPlan"
                        v-model="data.operationCircuit"
                        :class="{'p-invalid':v$.data.operationCircuit.$invalid && submitted, 'w-full p-inputtext-sm': true}" /> -->
                        <div v-if="(v$.data.operationCircuit.$invalid && submitted) || v$.data.operationCircuit.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.operationCircuit.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label :class="{'p-error':v$.data.operationDate.$invalid && submitted}">{{$t('tankOperations.operationDate')}}</label>
                        <Calendar
                            :class="{'p-invalid':v$.data.operationDate.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                            :placeholder="constants.DATE_PLACEHOLDER_POINT"
                            :dateFormat="constants.DATE_FORMAT_POINT"
                            :showTime="true" :hideOnDateTimeSelect="true"
                            :disabled="id != 0"
                            v-model="data.operationDate"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        <div v-if="(v$.data.operationDate.$invalid && submitted) || v$.data.operationDate.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.operationDate.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label :class="{'p-error':v$.data.measureType.$invalid && submitted}">{{$t('tankOperations.measureType')}}</label>
                        <Dropdown
                            :class="{'p-invalid':v$.data.measureType.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                            :placeholder="null" v-model="data.measureType" :options="measureTypesOptions" optionValue="value">
                            <template #value="slotProps">
                            <div v-if="slotProps.value == 'LEVEL'">
                                <span>{{$t('tankOperations.measureTypeLevel')}}</span>
                            </div>
                            <div v-else-if="slotProps.value == 'QUANTITY'">
                                <span>{{$t('tankOperations.measureTypeQty')}}</span>
                            </div>
                            <div v-else>
                                <span class="p-dropdown-label">{{slotProps.value}}</span>
                            </div>
                        </template>
                            <template #option="slotProps">
                                <div v-if="slotProps.option.value == 'LEVEL'">
                                    <span>{{$t('tankOperations.measureTypeLevel')}}</span>
                                </div>
                                <div v-else-if="slotProps.option.value == 'QUANTITY'">
                                    <span>{{$t('tankOperations.measureTypeQty')}}</span>
                                </div>
                            </template>
                        </Dropdown>
                        <div v-if="(v$.data.measureType.$invalid && submitted) || v$.data.measureType.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.measureType.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label :class="{'p-error':v$.data.managementType.$invalid && submitted}">{{$t('tankOperations.managementType')}}</label>
                        <Dropdown
                            :class="{'p-invalid':v$.data.managementType.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                            :placeholder="null" v-model="data.managementType" :options="managementTypesOptions" >
                        </Dropdown>
                        <div v-if="(v$.data.managementType.$invalid && submitted) || v$.data.managementType.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.managementType.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <!-- <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.voyageNumber')}}</label>
                        <InputText
                        :disabled="true" type="text"
                        v-model="data.voyageNumber"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.fiscalCommunicationCode')}}</label>
                        <InputText
                        :disabled="true" type="text"
                        v-model="data.fiscalCommunicationCode"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.fiscalDocumentNumber')}}</label>
                        <InputText
                        :disabled="true" type="text"
                        v-model="data.fiscalDocumentNumber"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.fiscalDocumentType')}}</label>
                        <InputText
                        :disabled="true" type="text"
                        v-model="data.fiscalDocumentType"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div> -->
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label :class="{'p-error':v$.data.fiscalStockWeight.$invalid && submitted}">{{$t('tankOperations.fiscalStockWeight')}}</label>
                        <InputNumber
                        :disabled="isAzzPd"
                        :readonly="this.data.measureType == 'LEVEL'"
                        v-model="data.fiscalStockWeight"
                        :class="{'p-invalid':v$.data.fiscalStockWeight.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.fiscalStockWeight.$invalid && submitted) || v$.data.fiscalStockWeight.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.fiscalStockWeight.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.fiscalStockVolume')}}</label>
                        <InputNumber
                        :readonly="this.data.measureType == 'LEVEL'"
                        :disabled="isAzzPd"
                        v-model="data.fiscalStockVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label :class="{'p-error':v$.data.fiscalMovedWeight.$invalid && submitted}">{{$t('tankOperations.fiscalMovedWeight')}}</label>
                        <InputNumber
                        :readonly="this.data.measureType == 'LEVEL'"
                        :disabled="isAzzPd"
                        v-model="data.fiscalMovedWeight"
                        :class="{'p-invalid':v$.data.fiscalMovedWeight.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.fiscalMovedWeight.$invalid && submitted) || v$.data.fiscalMovedWeight.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.fiscalMovedWeight.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.fiscalMovedVolume')}}</label>
                        <InputNumber
                        :readonly="this.data.measureType == 'LEVEL'"
                        :disabled="isAzzPd"
                        v-model="data.fiscalMovedVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" :class="{'p-error':v$.data.density15.$invalid && submitted}">
                        <label>{{$t('tankOperations.density15')}}</label>
                        <InputNumber mode="decimal"
                        :disabled="isAzzPd"
                        v-model="data.density15" :minFractionDigits="5" :maxFractionDigits="5"
                        :class="{'p-invalid':v$.data.density15.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.density15.$invalid && submitted) || v$.data.density15.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.density15.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label for="idRegistryProduct" :class="{'p-error':v$.data.idRegistryProduct.$invalid && submitted}">{{$t('product.fk')}}</label>
                        <GenericCustomMasterDataAutocompleteV2
                            :disabled="false"
                            :changeFn="onProductSelected"
                            v-model="data.idRegistryProduct"
                            name="products"
                            api="masterdata/product-combo"
                            :class="{'p-invalid':v$.data.idRegistryProduct.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.idRegistryProduct.$invalid && submitted) || v$.data.idRegistryProduct.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.idRegistryProduct.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label for="combinedNomenclature" :class="{'p-error':v$.data.combinedNomenclature.$invalid && submitted}">{{$t('fiscalNotification.nc')}}</label>
                        <!-- <InputText type="text"
                        v-model="data.combinedNomenclature"
                        :class="{ 'w-full p-inputtext-sm': true}" /> -->
                        <GenericCustomAutocompleteV2
                        v-model="data.combinedNomenclature"
                            :disabled="isFromDailyPlan && !isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled"
                        name="energyProductDetail"
                        ref="ncCombo"
                        :format="{ label: 'label', value: 'valueString' }"
                        :class="{'p-invalid':v$.data.combinedNomenclature.$invalid && submitted, 'w-full p-inputtext-sm': true}"  />
                        <div v-if="(v$.data.combinedNomenclature.$invalid && submitted) || v$.data.combinedNomenclature.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.combinedNomenclature.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                </div>
            </FieldSet>
            <div class="col-12 field">
                <label>{{$t('tankOperations.calculationMode')}}</label>
                <RadioButton class="m-2" value="TANK" v-model="filter.calculationMode" />
                <label>{{$t('tankCalculator.tank')}}</label>
                <RadioButton class="m-2" value="DISCHARGE" v-model="filter.calculationMode" />
                <label>{{$t('tankCalculator.discharge')}}</label>
            </div>
            <Fieldset class="col-12" :legend="$t('tankOperations.levelData')">
                <div class="grid">
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.temperature.$invalid && submitted}">
                        <label>{{$t('tankOperations.temperature')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.temperature" :minFractionDigits="2" :maxFractionDigits="2"
                        :class="{'p-invalid':v$.data.temperature.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.temperature.$invalid && submitted) || v$.data.temperature.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.temperature.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.productLevel.$invalid && submitted}">
                        <label>{{$t('tankOperations.productLevel')}}</label>
                        <InputNumber
                        v-model="data.productLevel"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.productLevel.$invalid && submitted) || v$.data.productLevel.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.productLevel.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.waterLevel.$invalid && submitted}">
                        <label>{{$t('tankOperations.waterLevel')}}</label>
                        <InputNumber
                        v-model="data.waterLevel"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.waterLevel.$invalid && submitted) || v$.data.waterLevel.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.waterLevel.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" :class="{'p-error':v$.data.waterVolume.$invalid && submitted}">
                        <label>{{$t('tankOperations.waterVolume')}}</label>
                        <InputNumber
                        v-model="data.waterVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.waterVolume.$invalid && submitted) || v$.data.waterVolume.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.waterVolume.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.grossVolume.$invalid && submitted}">
                        <label>{{$t('tankOperations.grossVolume')}}</label>
                        <InputNumber
                        v-model="data.grossVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.grossVolume.$invalid && submitted) || v$.data.grossVolume.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.grossVolume.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.fX54.$invalid && submitted}">
                        <label>{{$t('tankOperations.fX54')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.fX54" :minFractionDigits="4" :maxFractionDigits="4"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.fX54.$invalid && submitted) || v$.data.fX54.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.fX54.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.fX56.$invalid && submitted}">
                        <label>{{$t('tankOperations.fX56')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.fX56" :minFractionDigits="4" :maxFractionDigits="4"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.fX56.$invalid && submitted) || v$.data.fX56.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.fX56.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas" :class="{'p-error':v$.data.gasPressure.$invalid && submitted}">
                        <label>{{$t('tankOperations.gasPressure')}}</label>
                        <InputNumber
                        v-model="data.gasPressure"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.gasPressure.$invalid && submitted) || v$.data.gasPressure.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.gasPressure.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.stockVolume15.$invalid && submitted}">
                        <label>{{$t('tankOperations.stockVolume15')}}</label>
                        <InputNumber
                        v-model="data.stockVolume15"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.stockVolume15.$invalid && submitted) || v$.data.stockVolume15.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.stockVolume15.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.stockWeight.$invalid && submitted}">
                        <label>{{$t('tankOperations.stockWeight')}}</label>
                        <InputNumber
                        v-model="data.stockWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.stockWeight.$invalid && submitted) || v$.data.stockWeight.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.stockWeight.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <!-- <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('tankOperations.movedVolume')}}</label>
                        <InputNumber
                        v-model="data.movedVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('tankOperations.movedWeight')}}</label>
                        <InputNumber
                        v-model="data.movedWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div> -->
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas">
                        <label>{{$t('tankOperations.steamVolume')}}</label>
                        <InputNumber
                        v-model="data.steamVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('tankOperations.stockVolume')}}</label>
                        <InputNumber
                        v-model="data.stockVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.removableVolume.$invalid && submitted}">
                        <label>{{$t('tankOperations.removableVolume')}}</label>
                        <InputNumber
                        v-model="data.removableVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.removableVolume.$invalid && submitted) || v$.data.removableVolume.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.removableVolume.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'" :class="{'p-error':v$.data.removableWeight.$invalid && submitted}">
                        <label>{{$t('tankOperations.removableWeight')}}</label>
                        <InputNumber
                        v-model="data.removableWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.removableWeight.$invalid && submitted) || v$.data.removableWeight.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.removableWeight.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas" :class="{'p-error':v$.data.steamWeight.$invalid && submitted}">
                        <label>{{$t('tankOperations.steamWeight')}}</label>
                        <InputNumber
                        v-model="data.steamWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.steamWeight.$invalid && submitted) || v$.data.steamWeight.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.steamWeight.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas" :class="{'p-error':v$.data.molecularWeight.$invalid && submitted}">
                        <label>{{$t('tankOperations.molecularWeight')}}</label>
                        <InputNumber mode="decimal"
                        :minFractionDigits="4" :maxFractionDigits="4"
                        v-model="data.molecularWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.molecularWeight.$invalid && submitted) || v$.data.molecularWeight.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.molecularWeight.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas" :class="{'p-error':v$.data.gasTemperature.$invalid && submitted}">
                        <label>{{$t('tankOperations.gasTemperature')}}</label>
                        <InputNumber mode="decimal"
                        :minFractionDigits="2" :maxFractionDigits="2"
                        v-model="data.gasTemperature"
                        :class="{'w-full p-inputtext-sm': true}" />
                        <div v-if="(v$.data.gasTemperature.$invalid && submitted) || v$.data.gasTemperature.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.gasTemperature.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas">
                        <label>{{$t('tankOperations.shrinkage')}}</label>
                        <InputNumber mode="decimal"
                        :minFractionDigits="4" :maxFractionDigits="4"
                        v-model="data.shrinkage"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && data.isGas">
                        <label>{{$t('tankOperations.shrinkageGas')}}</label>
                        <InputNumber mode="decimal"
                        :minFractionDigits="4" :maxFractionDigits="4"
                        v-model="data.shrinkageGas"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('tankOperations.denaturantQuantity')}}</label>
                        <InputNumber mode="decimal"
                        :minFractionDigits="4" :maxFractionDigits="4"
                        v-model="data.denaturantQuantity"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('tankOperations.roofVolume')}}</label>
                        <InputNumber
                        v-model="data.roofVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="productData && productData.extraData && productData.extraData.isBiofeed">
                        <label>{{$t('tankOperations.roofWeight')}}</label>
                        <InputNumber
                        v-model="data.roofWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('calculatorTankDevelopment.footPosition')}}</label>
                        <Dropdown class="w-full p-inputtext-sm" @:placeholder="null" v-model="data.feetPosition" :options="footPositionOptions" optionValue="value">
                            <template #value="slotProps">
                            <div v-if="slotProps.value == 'D'">
                                <span>{{$t('calculatorTankDevelopment.footPositionD')}}</span>
                            </div>
                            <div v-else-if="slotProps.value == 'U'">
                                <span>{{$t('calculatorTankDevelopment.footPositionH')}}</span>
                            </div>
                            <div v-else>
                                <span class="p-dropdown-label">{{slotProps.value}}</span>
                            </div>
                        </template>
                            <template #option="slotProps">
                                <div v-if="slotProps.option.value == 'D'">
                                    <span>{{$t('calculatorTankDevelopment.footPositionD')}}</span>
                                </div>
                                <div v-else-if="slotProps.option.value == 'U'">
                                    <span>{{$t('calculatorTankDevelopment.footPositionH')}}</span>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field">
                        <label>{{$t('tankOperations.environmentTemperature')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.environmentTemperature" :minFractionDigits="2" :maxFractionDigits="2"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" >
                        <label>{{$t('tankOperations.environmentTemperatureSensor')}}</label>
                        <InputText  type="text"
                        v-model="data.environmentTemperatureSensor"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>

                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'">
                        <label>{{$t('tankOperations.shellTemperature')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.shellTemperature" :minFractionDigits="2" :maxFractionDigits="2"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'">
                        <label>{{$t('tankOperations.thermalExpansionFactor')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.thermalExpansionFactor" :minFractionDigits="5" :maxFractionDigits="5"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'">
                        <label>{{$t('tankOperations.deltaTemperatura')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.deltaTemperatura" :minFractionDigits="2" :maxFractionDigits="2"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'">
                        <label>{{$t('tankOperations.shellVolume')}}</label>
                        <InputNumber
                        v-model="data.shellVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && (productData && productData.extraData && productData.extraData.isBiofeed)">
                        <label>{{$t('tankOperations.volumeExpansionFactor')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.volumeExpansionFactor" :minFractionDigits="5" :maxFractionDigits="5"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && (productData && productData.extraData && productData.extraData.isBiofeed)">
                        <label>{{$t('tankOperations.emptyStockWeight')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.emptyStockWeight" :minFractionDigits="0" :maxFractionDigits="0"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'">
                        <label>{{$t('tankOperations.biofeedWeightCorrectiornFactor')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.biofeedWeightCorrectiornFactor" :minFractionDigits="6" :maxFractionDigits="6"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>

                    <!-- campi discarica -->

                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL'">
                        <label>{{$t('tankOperations.sulfurPercentage')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.sulfurPercentage" :minFractionDigits="2" :maxFractionDigits="2"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.emptyStockWeight')}}</label>
                        <InputNumber
                        v-model="data.emptyStockWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.introducedGrossVolume')}}</label>
                        <InputNumber
                        v-model="data.introducedGrossVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.introducedGrossWeight')}}</label>
                        <InputNumber
                        v-model="data.introducedGrossWeight"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.sampleBarrelDensity15')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.sampleBarrelDensity15" :minFractionDigits="4" :maxFractionDigits="4"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.weightedAverageDensity')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.weightedAverageDensity" :minFractionDigits="4" :maxFractionDigits="4"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.waterAndSedimentsVolumePercentage')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.waterAndSedimentsVolumePercentage" :minFractionDigits="2" :maxFractionDigits="2"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.waterAndSedimentsCorrectionFactor')}}</label>
                        <InputNumber mode="decimal"
                        v-model="data.waterAndSedimentsCorrectionFactor" :minFractionDigits="4" :maxFractionDigits="4"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                    <div class="col-12 lg:col-3 md:col-4 field" v-if="data.measureType == 'LEVEL' && filter.calculationMode == 'DISCHARGE'">
                        <label>{{$t('tankOperations.waterAndSedimentsIntroducedVolume')}}</label>
                        <InputNumber
                        v-model="data.waterAndSedimentsIntroducedVolume"
                        :class="{'w-full p-inputtext-sm': true}" />
                    </div>
                </div>
            </FieldSet>
        </div>
    </main>
</template>